<template>
  <Catalogs
    title="Подразделения"
    create-text="Новое"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'DepartmentAdd'"
    :route-edit="'DepartmentEdit'"
    :route-view="'DepartmentView'"
    :route-path="'/departments'"
    :can-edit="canEditDepartmentCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "Departments",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: false,
          class: 'department-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: false,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'department-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getDepartments(data);
    },
    canEditDepartmentCatalogs() {
      return this.hasPermission([PERM.CATALOG_DEPARTMENT_EDIT]);
    }
  }
}
</script>

<style>
.department-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.department-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Departments/Departments.vue